import React from 'react';
import { Box, TextField, Button, Grid } from '@mui/material';
import { DateRange } from '@mui/icons-material';

interface DateRangePickerProps {
  startDate: string;
  endDate: string;
  onChange: (startDate: string, endDate: string) => void;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  onChange,
}) => {
  const [localStartDate, setLocalStartDate] = React.useState(startDate);
  const [localEndDate, setLocalEndDate] = React.useState(endDate);

  const handleApply = () => {
    onChange(localStartDate, localEndDate);
  };

  const handleQuickSelect = (days: number) => {
    const end = new Date().toISOString().split('T')[0];
    const start = new Date(Date.now() - days * 24 * 60 * 60 * 1000)
      .toISOString()
      .split('T')[0];
    setLocalStartDate(start);
    setLocalEndDate(end);
    onChange(start, end);
  };

  return (
    <Box>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={4}>
          <TextField
            label="Start Date"
            type="date"
            value={localStartDate}
            onChange={(e) => setLocalStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="End Date"
            type="date"
            value={localEndDate}
            onChange={(e) => setLocalEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Button
            variant="contained"
            startIcon={<DateRange />}
            onClick={handleApply}
            fullWidth
          >
            Apply
          </Button>
        </Grid>
      </Grid>
      
      <Box sx={{ display: 'flex', gap: 1, mt: 2, flexWrap: 'wrap' }}>
        <Button size="small" variant="outlined" onClick={() => handleQuickSelect(7)}>
          Last 7 Days
        </Button>
        <Button size="small" variant="outlined" onClick={() => handleQuickSelect(30)}>
          Last 30 Days
        </Button>
        <Button size="small" variant="outlined" onClick={() => handleQuickSelect(90)}>
          Last 90 Days
        </Button>
      </Box>
    </Box>
  );
};

export default DateRangePicker;
